const React = require('react');
const {t} = require('services/i18nextWrapper');
require('./DashboardViewOnlyIndicator.scss');

const DashboardViewOnlyIndicator = React.createClass({displayName: "DashboardViewOnlyIndicator",
    render() {
        const {isAllSectionActive} = this.props;
        return (
            React.createElement("div", {className: "bp-dashboard-view-only-indicator"}, 
                isAllSectionActive
                    ? t('label_view_only_mode')
                    : t('label_not_drag_mode')
            )
        );
    }
});

module.exports = DashboardViewOnlyIndicator;



/** WEBPACK FOOTER **
 ** ./src/views/Dashboard/DashboardViewOnlyIndicator.js
 **/